// extracted by mini-css-extract-plugin
export var editor = "_1l-0";
export var flowSidebar = "_4u-2";